import { useMemo } from "react";

import { Select } from "neetoui/formik";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { getCurrencies } from "./utils";

const FormikCurrency = ({
  label,
  name = "currency",
  allowedCurrencies,
  ...otherSelectProps
}) => {
  const { t } = useTranslation();

  const data = useMemo(
    () => getCurrencies(allowedCurrencies),
    [allowedCurrencies]
  );

  return (
    <Select
      {...{ name }}
      label={label || t("neetoMolecules.common.currency")}
      options={data}
      {...otherSelectProps}
    />
  );
};

FormikCurrency.propTypes = {
  /**
   * Label for the currency input.
   */
  label: PropTypes.string,
  /**
   * Name for the currency input.
   */
  name: PropTypes.string,
  /**
   * To specify only a selected list of currencies to be used.
   */
  allowedCurrencies: PropTypes.arrayOf(PropTypes.string),
};

export default FormikCurrency;
